import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

const BranchContext = createContext(null);
const KEY = "evergro_branch";

export function BranchProvider({ children }) {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelectedState] = useState(() => localStorage.getItem(KEY) || "all");

  const refresh = useCallback(async () => {
    if (!user || user.role !== "user" || !user.is_joining_paid) { setLoading(false); return; }
    try {
      const { data } = await api.get("/branches");
      setBranches(data.branches || []);
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  // Only branches owned by this login can be selected; anything else falls back to combined view.
  const valid = selected === "all" || branches.some((b) => b.id === selected);
  const current = valid && selected !== "all" ? branches.find((b) => b.id === selected) : null;
  const setSelected = (id) => { localStorage.setItem(KEY, id); setSelectedState(id); };

  return (
    <BranchContext.Provider value={{ branches, loading, refresh, selected: valid ? selected : "all", current, setSelected }}>
      {children}
    </BranchContext.Provider>
  );
}

export const useBranches = () => useContext(BranchContext);

export const referralLink = (code) => `${window.location.origin}/register?ref=${code}`;

export const STATUS_STYLE = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending_payment: "bg-amber-50 text-amber-700 border-amber-200",
  suspended: "bg-red-50 text-red-700 border-red-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  refunded: "bg-slate-100 text-slate-600 border-slate-200",
};

export const STATUS_LABEL = { active: "Active", pending_payment: "Pending payment", suspended: "Suspended", cancelled: "Cancelled", refunded: "Refunded" };

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
